import { render, staticRenderFns } from "./prvChatEnd.vue?vue&type=template&id=6bc107b9&scoped=true&"
import script from "./prvChatEnd.vue?vue&type=script&lang=js&"
export * from "./prvChatEnd.vue?vue&type=script&lang=js&"
import style0 from "./prvChatEnd.vue?vue&type=style&index=0&id=6bc107b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc107b9",
  null
  
)

export default component.exports